/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} News_Meta_PageInputs */

const ja_news_meta_page = /** @type {(inputs: News_Meta_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`news`)
};

const en_news_meta_page = /** @type {(inputs: News_Meta_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`news`)
};

/**
* | output |
* | --- |
* | "news" |
*
* @param {News_Meta_PageInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const news_meta_page = /** @type {((inputs?: News_Meta_PageInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<News_Meta_PageInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_news_meta_page(inputs)
	return en_news_meta_page(inputs)
});